export default __webpack_public_path__ + "static/media/logo.c74bf15f.svg";